import { purchaseLabel } from "@redotech/merchant-sdk/rpc/schema/purchase-label";
import { useRequiredContext } from "@redotech/react-util/context";
import { RedoMerchantRpcClientContext } from "@redotech/redo-merchant-app-common/rpc-client";
import { useMutation, useQueryClient } from "@tanstack/react-query";
import type * as z from "zod";
import { getLabelRatesQueryKey } from "./use-label-rates";

export type PurchaseLabelProps = z.infer<typeof purchaseLabel.input>;
export type PurchaseLabelResult = z.infer<typeof purchaseLabel.output>;

export function usePurchaseLabel() {
  const rpcClient = useRequiredContext(RedoMerchantRpcClientContext);
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: async (props: PurchaseLabelProps) => {
      return rpcClient.purchaseLabel({
        teamId: props.teamId,
        returnId: props.returnId,
        rate: props.rate,
        weight: props.weight,
        shipmentId: props.shipmentId,
        shipmentGroupId: props.shipmentGroupId,
        toAddress: props.toAddress,
        fromAddress: props.fromAddress,
        labelType: props.labelType,
        originalLabelCost: props.originalLabelCost,
        replacedDropoffGroupId: props.replacedDropoffGroupId,
        isAdditionalShipment: props.isAdditionalShipment,
        isReShipment: props.isReShipment,
      });
    },
    onSuccess: (_data, variables) => {
      void queryClient.invalidateQueries({
        queryKey: getLabelRatesQueryKey(variables.teamId, variables.returnId),
      });
    },
  });
}
